import React, { useEffect, useState } from 'react'
import './FilingToRecordTypes.scss'
import { Checkbox, ContextButton, SelectBox } from '@tecuity/granite-ui'
import {
  GET_ALL_IMAGE_PAGE_TYPES,
  GET_ALL_NOTARY_FILING_TYPES,
  GET_ALL_NOTARY_RECORD_TYPES,
  GET_ALL_NOTARY_STATUS_TYPES,
  GET_ALL_RECORD_USER_ACCESS_ROLES,
  GET_APP_REPORTS,
  GET_ALL_FORMS_BY_CATEGORY,
  GET_NOTARY_FILING_TO_RECORD_XREF_BY_ID,
  GET_NOTARY_FILING_TO_RECORD_XREF_BY_TYPES,
  DELETE_NOTARY_FILING_TO_RECORD_XREF_BY_ID,
  EDIT_NOTARY_FILING_TO_RECORD_XREF,
  ADD_NOTARY_FILING_TO_RECORD_XREF,
} from '../../../requests'
import { useRequestData } from '../../../Utilities/hooks'
import Revert from '@tecuity/sos-icons/react/revert'
import RightArrow from '@tecuity/sos-icons/react/right-arrow'
import { setErrorToast, setSuccessToast } from '../../../actions'
import { useDispatch } from 'react-redux'

const sanitizeData = (obj) => {
  return {
    ...obj,
    NotaryRecordTypeId: Number(obj.NotaryRecordTypeId),
    ImagePageTypeId:
      obj.ImagePageTypeId === '' || obj.ImagePageTypeId === 0 ? null : Number(obj.ImagePageTypeId),
    FormDefinitionId:
      obj.FormDefinitionId === '' || obj.FormDefinitionId === 0
        ? null
        : Number(obj.FormDefinitionId),
    NewNotaryStatusId:
      obj.NewNotaryStatusId === '' || obj.NewNotaryStatusId === 0
        ? null
        : Number(obj.NewNotaryStatusId),
  }
}

const SelectableCheckbox = ({ label, active, onClick, onChange, checked, disabled }) => {
  return (
    <div
      className={active ? 'active checkboxWrapper' : 'checkboxWrapper'}
      onClick={() => onClick()}
    >
      <Checkbox
        ariaLabel={label}
        customCss={'width: fit-content'}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <div className="checkboxLabel">{label}</div>
    </div>
  )
}

const SelectableCheckboxList = ({
  label,
  items,
  activeId,
  setActiveId,
  setChecked,
  checked,
  setActiveChanges,
  clearProperties,
  disabled,
}) => {
  return (
    <div>
      <div className="label">{label}</div>
      <div className="scrollableCheckboxList selectable">
        {items.map(({ label, id }) => {
          return (
            <SelectableCheckbox
              label={label}
              key={id}
              active={activeId === id}
              onClick={() => {
                !disabled && setActiveId(id)
              }}
              onChange={() => {
                clearProperties()
                setActiveChanges()
                let nextChecked = [...checked]
                if (!nextChecked.includes(id)) {
                  // doesn't exist or is already false
                  nextChecked.push(id)
                } else {
                  nextChecked = nextChecked.filter((item) => item !== id)
                }
                setChecked(nextChecked)
              }}
              checked={checked.includes(id) ? true : false}
              disabled={disabled}
            />
          )
        })}
      </div>
    </div>
  )
}

const CheckboxList = ({ label, items, checkedIds, setChecked, setActiveChanges, disabled }) => {
  return (
    <div>
      <div className="label">{label}</div>
      <div className="scrollableCheckboxList">
        {items.map(({ label, id }) => {
          return (
            <Checkbox
              label={label}
              key={id}
              checked={checkedIds.includes(id) ? true : false}
              onChange={() => {
                setActiveChanges()
                let nextChecked = [...checkedIds]
                if (!nextChecked.includes(id)) {
                  // doesn't exist or is already false
                  nextChecked.push(id)
                } else {
                  nextChecked = nextChecked.filter((item) => item !== id)
                }
                setChecked(nextChecked)
              }}
              disabled={disabled}
            />
          )
        })}
      </div>
    </div>
  )
}

export const FilingToRecordTypes = () => {
  const recordTypes = useRequestData(GET_ALL_NOTARY_RECORD_TYPES)
  const filingTypes = useRequestData(GET_ALL_NOTARY_FILING_TYPES)
  const statusTypes = useRequestData(GET_ALL_NOTARY_STATUS_TYPES)
  const imagePageTypes = useRequestData(GET_ALL_IMAGE_PAGE_TYPES)
  const recordOwnerTypes = useRequestData(GET_ALL_RECORD_USER_ACCESS_ROLES)
  const appReports = useRequestData(GET_APP_REPORTS)
  const formData = useRequestData((cb, errCb) => GET_ALL_FORMS_BY_CATEGORY('notary', cb, errCb))
  const [activeChanges, setActiveChanges] = useState({ filingTypeId: null, hasChanges: false })
  const [selectedRecordType, setSelectedRecordType] = useState('')
  const [selectedFilingType, setSelectedFilingType] = useState('')
  const [checkedFilingTypes, setCheckedFilingTypes] = useState([])
  const [checkedStatusesToFile, setCheckedStatusToFile] = useState([])

  const [AccessUserRolePermitted, setAccessUserRolePermitted] = useState([])
  const [AccessUserRolePostApproval, setAccessUserRolePostApproval] = useState(-1)

  const [selectedImagePageType, setSelectedImagePageType] = useState('')
  const [selectedFormTitleId, setSelectedFormTitleId] = useState('')
  const [selectedStatusAfterFiling, setSelectedStatusAfterFiling] = useState('')
  const [includeImageForPaperFiling, setIncludeImageForPaperFiling] = useState(false)
  const [limitOnePendingFilingPerRecord, setLimitOnePendingFilingPerRecord] = useState(false)
  const [checkedGeneratedReports, setCheckedGeneratedReports] = useState([])
  const [initialState, setInitialState] = useState({})
  const [bulkData, setBulkData] = useState({})
  const [refreshDataFlag, setRefreshDataFlag] = useState(false)
  const dispatch = useDispatch()
  const disableFilingTypeSettings = !checkedFilingTypes.includes(selectedFilingType)

  const currentFilingToRecordXRef = useRequestData(
    (cb, errCb) => GET_NOTARY_FILING_TO_RECORD_XREF_BY_ID(selectedRecordType, cb, errCb),
    [selectedRecordType, refreshDataFlag]
  )

  const currentFilingToRecordXrefInfo = useRequestData(
    (cb, errCb) =>
      GET_NOTARY_FILING_TO_RECORD_XREF_BY_TYPES(selectedRecordType, selectedFilingType, cb, errCb),
    [selectedFilingType, selectedRecordType]
  )

  const clearProperties = () => {
    setCheckedStatusToFile([])
    setSelectedImagePageType('')
    setSelectedFormTitleId('')
    setSelectedStatusAfterFiling('')
    setIncludeImageForPaperFiling(false)
    setLimitOnePendingFilingPerRecord(false)
    setCheckedGeneratedReports([])

    setAccessUserRolePermitted([])
    setAccessUserRolePostApproval(-1)
  }

  useEffect(() => {
    const nextCheckedFilingTypes = []
    if (currentFilingToRecordXRef && typeof currentFilingToRecordXRef === 'object') {
      const nextInitialState = { ...initialState }
      currentFilingToRecordXRef.forEach((filingToRecordLink) => {
        // checked filing types
        nextCheckedFilingTypes.push(filingToRecordLink.Id)
        GET_NOTARY_FILING_TO_RECORD_XREF_BY_TYPES(
          selectedRecordType,
          filingToRecordLink.Id,
          (response) => {
            const filingTypeSettings = {
              NotaryFilingTypeId: filingToRecordLink.Id,
              NotaryRecordTypeId: selectedRecordType,
              FormDefinitionId: response.FormDefinitionId,
              NewNotaryStatusId: response.NewNotaryStatusId,
              PriorNotaryStatusIds: JSON.parse(response.PriorNotaryStatusIdsJson),
              IncludeImageForPaperFiling: response.IncludeImageForPaperFiling,
              LimitOnePendingFilingPerRecord: response.LimitOnePendingFilingPerRecord,
              ReportIds: JSON.parse(response.ReportConfigJson),
              ImagePageTypeId: response.ImagePageTypeId,
              AccessUserRolePermitted : response.AccessUserRolePermitted.map(x => x.Id),
              AccessUserRolePostApproval : response.AccessUserRolePostApproval ? response.AccessUserRolePostApproval.Id : -1
            }
            nextInitialState[filingToRecordLink.Id] = filingTypeSettings
          }
        )
      })
      setInitialState(nextInitialState)
    }
    setCheckedFilingTypes(nextCheckedFilingTypes)
  }, [currentFilingToRecordXRef])

  useEffect(() => {
    if (!checkedFilingTypes.includes(selectedFilingType)) {
      clearProperties()
    } else if (bulkData[selectedFilingType]) {
      const savedChanges = bulkData[selectedFilingType]
      setCheckedStatusToFile(savedChanges.PriorNotaryStatusIds || [])
      setSelectedImagePageType(savedChanges.ImagePageTypeId || '')
      setSelectedFormTitleId(savedChanges.FormDefinitionId || '')
      setSelectedStatusAfterFiling(savedChanges.NewNotaryStatusId || '')
      setIncludeImageForPaperFiling(savedChanges.IncludeImageForPaperFiling)
      setLimitOnePendingFilingPerRecord(savedChanges.LimitOnePendingFilingPerRecord)
      setCheckedGeneratedReports(savedChanges.ReportIds || [])
      setAccessUserRolePermitted(savedChanges.AccessUserRolePermitted || [])
      setAccessUserRolePostApproval(savedChanges.AccessUserRolePostApproval ? savedChanges.AccessUserRolePostApproval.Id : -1)

    } else if (currentFilingToRecordXrefInfo && currentFilingToRecordXrefInfo.NotaryRecordTypeId) {
      // Status to File
      // setCheckedStatusToFile()
      setCheckedStatusToFile(
        JSON.parse(currentFilingToRecordXrefInfo.PriorNotaryStatusIdsJson) || []
      )

      // Image Page Type
      setSelectedImagePageType(currentFilingToRecordXrefInfo.ImagePageTypeId || '')

      // Form Title
      setSelectedFormTitleId(currentFilingToRecordXrefInfo.FormDefinitionId || '')

      // Status After Filing
      setSelectedStatusAfterFiling(currentFilingToRecordXrefInfo.NewNotaryStatusId || '')

      setIncludeImageForPaperFiling(currentFilingToRecordXrefInfo.IncludeImageForPaperFiling)

      setLimitOnePendingFilingPerRecord(currentFilingToRecordXrefInfo.LimitOnePendingFilingPerRecord)

      // Generated Reports
      setCheckedGeneratedReports(JSON.parse(currentFilingToRecordXrefInfo.ReportConfigJson) || [])

      setAccessUserRolePermitted(currentFilingToRecordXrefInfo.AccessUserRolePermitted || [])
      setAccessUserRolePostApproval(currentFilingToRecordXrefInfo.AccessUserRolePostApproval ? currentFilingToRecordXrefInfo.AccessUserRolePostApproval.Id : -1)
    }
  }, [currentFilingToRecordXrefInfo, selectedFilingType])

  useEffect(() => {
    /*  
     when the user changes which filing type is selected, and only 
     if a checked filing type has had user-activated changes made
    */
    if (activeChanges.filingTypeId === selectedFilingType) {
      return
    }

    if (!activeChanges.hasChanges) {
      return
    }

    const nextBulkData = { ...bulkData }

    const currentFilingTypeSettings = {
      NotaryFilingTypeId: activeChanges.filingTypeId,
      NotaryRecordTypeId: +selectedRecordType,
      FormDefinitionId: +selectedFormTitleId,
      NewNotaryStatusId: +selectedStatusAfterFiling,
      PriorNotaryStatusIds: [...checkedStatusesToFile],
      IncludeImageForPaperFiling: includeImageForPaperFiling,
      LimitOnePendingFilingPerRecord: limitOnePendingFilingPerRecord,
      ReportIds: [...checkedGeneratedReports],
      ImagePageTypeId: selectedImagePageType,
      //RequiredRecordOwnerTypeId: +selectedRequiredRecordOwnerType,
      //NewRecordOwnerTypeId: +selectedNewRecordOwnerType,
      AccessUserRolePermitted : AccessUserRolePermitted,
      AccessUserRolePostApproval : AccessUserRolePostApproval
    }
    nextBulkData[activeChanges.filingTypeId] = currentFilingTypeSettings
    setBulkData(nextBulkData)
    setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: false })
  }, [selectedFilingType, activeChanges])

  const handleRevert = (fromSave = false) => {
    const nextCheckedFilingTypes = []
    setBulkData({})
    if (currentFilingToRecordXRef && typeof currentFilingToRecordXRef === 'object') {
      const nextInitialState = {}

      currentFilingToRecordXRef.forEach((filingToRecordLink) => {
        // checked filing types
        nextCheckedFilingTypes.push(filingToRecordLink.Id)
        GET_NOTARY_FILING_TO_RECORD_XREF_BY_TYPES(
          selectedRecordType,
          filingToRecordLink.Id,
          (response) => {
            if (!response) {
              return
            }
            const filingTypeSettings = {
              NotaryFilingTypeId: filingToRecordLink.Id,
              NotaryRecordTypeId: selectedRecordType,
              FormDefinitionId: response.FormDefinitionId,
              NewNotaryStatusId: response.NewNotaryStatusId,
              PriorNotaryStatusIds: JSON.parse(response.PriorNotaryStatusIdsJson),
              IncludeImageForPaperFiling: response.IncludeImageForPaperFiling,
              LimitOnePendingFilingPerRecord: response.LimitOnePendingFilingPerRecord,
              ReportIds: JSON.parse(response.ReportConfigJson),
              ImagePageTypeId: response.ImagePageTypeId,
            }
            nextInitialState[filingToRecordLink.Id] = filingTypeSettings
          },
          (errorResponse) => {
            console.error(errorResponse)
          }
        )
      })
      setInitialState(nextInitialState)
    }
    setCheckedFilingTypes(nextCheckedFilingTypes)
    setActiveChanges({ filingTypeId: null, hasChanges: false })
    if (!fromSave) {
      clearProperties()
      setSelectedFilingType('')
    }
  }

  const handleSave = () => {
    // for all filingTypes:
    const allFilingTypeIds = filingTypes.map((filingType) => filingType.Id)

    const finalData = { ...bulkData }
    const currentFilingTypeSettings = {
      NotaryFilingTypeId: activeChanges.filingTypeId,
      NotaryRecordTypeId: +selectedRecordType,
      FormDefinitionId: +selectedFormTitleId,
      NewNotaryStatusId: +selectedStatusAfterFiling,
      PriorNotaryStatusIds: [...checkedStatusesToFile],
      IncludeImageForPaperFiling: includeImageForPaperFiling,
      LimitOnePendingFilingPerRecord: limitOnePendingFilingPerRecord,
      ReportIds: [...checkedGeneratedReports],
      ImagePageTypeId: selectedImagePageType,
      AccessUserRolePermitted : AccessUserRolePermitted,
      AccessUserRolePostApproval : AccessUserRolePostApproval
    }

    // if changes to the current selected exist, make sure it is in the final data
    if (activeChanges.filingTypeId === selectedFilingType) {
      finalData[selectedFilingType] = currentFilingTypeSettings
    }

    // if the current selected was unchecked, mark it for deletion
    if (!checkedFilingTypes.includes(selectedFilingType)) {
      delete finalData[selectedFilingType]
    }

    const promiseArray = []

    allFilingTypeIds.forEach((filingTypeId) => {
      // if in initialState, but is no longer checked: DELETE
      if (initialState[filingTypeId] && !checkedFilingTypes.includes(filingTypeId)) {
        promiseArray.push(
          new Promise((resolve, reject) => {
            DELETE_NOTARY_FILING_TO_RECORD_XREF_BY_ID(
              selectedRecordType,
              filingTypeId,
              resolve,
              reject
            )
          })
        )
      }

      // if in initialState, and in finalData: PUT
      else if (initialState[filingTypeId] && finalData[filingTypeId]) {
        promiseArray.push(
          new Promise((resolve, reject) => {
            const sanitizedObject = sanitizeData(finalData[filingTypeId])
            EDIT_NOTARY_FILING_TO_RECORD_XREF(sanitizedObject, resolve, reject)
          })
        )
      }
      // if not in initialState, but in finalData: POST
      else if (!initialState[filingTypeId] && finalData[filingTypeId]) {
        promiseArray.push(
          new Promise((resolve, reject) => {
            const sanitizedObject = sanitizeData(finalData[filingTypeId])
            ADD_NOTARY_FILING_TO_RECORD_XREF(sanitizedObject, resolve, reject)
          })
        )
      }
    })

    Promise.all(promiseArray)
      .then((success) => {
        dispatch(setSuccessToast('Save was successful'))
        setRefreshDataFlag(!refreshDataFlag)
        handleRevert(true)
      })
      .catch((error) => {
        if (error.DisplayToUser === true && (error.Message || '') !== '') {
            dispatch(setErrorToast(error.Message))
          } else {
            dispatch(setErrorToast('Failed to save at least one filing Type.'))
          }
        console.error(error)
      })

    // setSelectedRecordType('');
  }

  React.useEffect(() => {
    if (!selectedRecordType) {
      setSelectedFilingType('')
      setCheckedFilingTypes([])
    }
  }, [selectedRecordType])

  return (
    <main className="FilingToRecordTypeWrapper">
      <div className="contentWrapper">
        <h2>Notary - Link Filing Type to Record Type</h2>
        <div className="selectBoxContainer">
          <SelectBox
            label="Record Type"
            description={
              Object.keys(bulkData).length > 0 || activeChanges.hasChanges
                ? 'Save or Revert changes to modify'
                : undefined
            }
            disabled={Object.keys(bulkData).length > 0 || activeChanges.hasChanges}
            options={
              recordTypes
                ? recordTypes
                    .filter((type) => {
                      return type.IsActive
                    })
                    .map((recordType) => {
                      return {
                        label: recordType.Name,
                        value: recordType.NotaryRecordTypeId,
                      }
                    })
                    .sort((a, b) => {
                      return a.label > b.label ? 1 : -1
                    })
                : []
            }
            value={selectedRecordType}
            onChange={(value) => setSelectedRecordType(value)}
          />
        </div>
        <div className="twoColumnLayout">
          <div className="columnItem">
            <SelectableCheckboxList
              clearProperties={clearProperties}
              label={'Filing Type'}
              items={
                filingTypes
                  ? filingTypes
                      .filter((type) => {
                        return type.IsActive
                      })
                      .map((filingType) => ({
                        id: filingType.NotaryFilingTypeId,
                        label: filingType.Name,
                      }))
                      .sort((a, b) => {
                        return a.label > b.label ? 1 : -1
                      })
                  : []
              }
              activeId={selectedFilingType}
              setActiveId={setSelectedFilingType}
              checked={checkedFilingTypes}
              setChecked={setCheckedFilingTypes}
              setActiveChanges={() =>
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
              }
              disabled={!selectedRecordType}
            />
          </div>
          <div className="columnItem">
            <CheckboxList
              label={'Status to File'}
              items={
                statusTypes
                  ? statusTypes
                      .filter((type) => {
                        return type.IsActive
                      })
                      .map((statusType) => ({
                        id: statusType.NotaryStatusTypeId,
                        label: statusType.Name,
                      }))
                      .sort((a, b) => {
                        return a.label > b.label ? 1 : -1
                      })
                  : []
              }
              checkedIds={checkedStatusesToFile}
              setChecked={setCheckedStatusToFile}
              setActiveChanges={() =>
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
              }
              disabled={disableFilingTypeSettings}
            />
            <SelectBox
              label="Image Page Type"
              options={
                imagePageTypes
                  ? imagePageTypes
                      .map((imagePageType) => {
                        return {
                          label: imagePageType.Name,
                          value: imagePageType.Id,
                        }
                      })
                      .sort((a, b) => {
                        return a.id > b.id ? 1 : -1
                      })
                  : []
              }
              onChange={(value) => {
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
                setSelectedImagePageType(value)
              }}
              value={selectedImagePageType}
              disabled={disableFilingTypeSettings}
            />
            <CheckboxList
              label="Record Access Roles Permitted to File (Leave blank to allow open filing)"
              items={
                recordOwnerTypes
                  ? recordOwnerTypes
                      .filter((x) => x.CanFileAmendments)
                      .map((recordOwnerType) => {
                        return {
                          label: recordOwnerType.Name,
                          id: recordOwnerType.Id,
                        }
                      })
                      .sort((a, b) => {
                        return a.id > b.id ? 1 : -1
                      })
                  : []
              }
              setActiveChanges={(value) => {
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
                //setSelectedRequiredRecordOwnerType(value)
              }}
              checkedIds={AccessUserRolePermitted}
              setChecked={setAccessUserRolePermitted}
              disabled={disableFilingTypeSettings}
            />
            <SelectBox
              label="Record Access Role Granted Post-Approval"
              options={
                recordOwnerTypes
                  ? recordOwnerTypes
                      .map((recordOwnerType) => {
                        return {
                          label: recordOwnerType.Name,
                          value: recordOwnerType.Id,
                        }
                      })
                      .sort((a, b) => {
                        return a.id > b.id ? 1 : -1
                      })
                  : []
              }
              onChange={(value) => {
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
                setAccessUserRolePostApproval(value === '' ? null : value)
              }}
              value={AccessUserRolePostApproval}
              disabled={disableFilingTypeSettings}
            />
            <SelectBox
              label="Form Title"
              options={
                formData
                  ? formData
                      .filter((form) => {
                        return form.IsActive
                      })
                      .map((form) => {
                        return {
                          label: form.Title,
                          value: form.FormDefinitionId,
                        }
                      })
                      .sort((a, b) => {
                        return a.label > b.label ? 1 : -1
                      })
                  : []
              }
              onChange={(value) => {
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
                setSelectedFormTitleId(value)
              }}
              value={selectedFormTitleId}
              disabled={disableFilingTypeSettings}
            />

            <Checkbox
              label="Only Allow One Pending Filing Per Record at a time"
              checked={limitOnePendingFilingPerRecord}
              onChange={(checked) => {
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
                setLimitOnePendingFilingPerRecord(checked)
              }}
              disabled={disableFilingTypeSettings}
            />
            <SelectBox
              label="Status After Filing"
              options={
                statusTypes
                  ? statusTypes
                      .filter((type) => {
                        return type.IsActive
                      })
                      .map((recordStatus) => {
                        return {
                          label: recordStatus.Name,
                          value: recordStatus.NotaryStatusTypeId,
                        }
                      })
                      .sort((a, b) => {
                        return a.label > b.label ? 1 : -1
                      })
                  : []
              }
              onChange={(value) => {
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
                setSelectedStatusAfterFiling(value)
              }}
              value={selectedStatusAfterFiling}
              disabled={disableFilingTypeSettings}
            />

            <Checkbox
              label="Include Original Image with Approval Stamp for Paper Filings"
              checked={includeImageForPaperFiling}
              onChange={(checked) => {
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
                setIncludeImageForPaperFiling(checked)
              }}
              disabled={disableFilingTypeSettings}
            />
            <CheckboxList
              label={'Generated Reports'}
              items={
                appReports
                  ? appReports
                      .map((appReport) => ({ id: appReport.Id, label: appReport.Name }))
                      .sort((a, b) => {
                        return a.label > b.label ? 1 : -1
                      })
                  : []
              }
              checkedIds={checkedGeneratedReports}
              setChecked={setCheckedGeneratedReports}
              setActiveChanges={() =>
                setActiveChanges({ filingTypeId: selectedFilingType, hasChanges: true })
              }
              disabled={disableFilingTypeSettings}
            />
            <div className="buttonGroup">
              <ContextButton
                variant="danger"
                leftIcon={
                  <div className="checkmark-wrapper left">
                    <Revert />
                  </div>
                }
                onClick={() => {
                  handleRevert()
                }}
              >
                Revert
              </ContextButton>
              <ContextButton
                variant="primary"
                rightIcon={
                  <div className="checkmark-wrapper right">
                    <RightArrow />
                  </div>
                }
                onClick={handleSave}
              >
                Save
              </ContextButton>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
